// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_Byi","cls2":"ReferenceReportPage-cls2_dnP ReferenceReportPage-cls1_Byi"};